/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.gemini.integration.rpc.AppSettingsRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GeminiAppError = {
  chirpErrorMessage: Default<string>;
  type: ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType = 'INVALID_API_KEY' | unhandledEnumCase;

export type ApiKeyUpdateRequest = { apiKey: string };

export type ApiKeyUpdateResponse = {};

export type AppInstallRequest = { apiKey: string };

export type AppInstallResponse = { responseField: string };

export type InstallRequestType = Requestify<AppInstallRequest>;
export type InstallResponseType = AppInstallResponse;
export type InstallErrorType = GeminiAppError & HubspotMetadata;
export const installRpc: ChirpAvroRpcDetails<
  InstallRequestType,
  InstallResponseType,
  InstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'install',
  auth: 'app',
  fingerprint: 'rw9ida76Tsh7WbGSwWSomTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UninstallResponseType = AppInstallResponse;
export type UninstallErrorType = GeminiAppError & HubspotMetadata;
export const uninstallRpc: ChirpAvroRpcDetails<
  undefined,
  UninstallResponseType,
  UninstallErrorType,
  false
> = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'uninstall',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAB7WbGSwWSomTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpsertApiKeyRequestType = Requestify<ApiKeyUpdateRequest>;
export type UpsertApiKeyResponseType = ApiKeyUpdateResponse;
export type UpsertApiKeyErrorType = GeminiAppError & HubspotMetadata;
export const upsertApiKeyRpc: ChirpAvroRpcDetails<
  UpsertApiKeyRequestType,
  UpsertApiKeyResponseType,
  UpsertApiKeyErrorType,
  false
> = {
  serviceName: 'com.hubspot.gemini.integration.rpc.AppSettingsRpc',
  rpcName: 'upsertApiKey',
  auth: 'app',
  fingerprint: 'Sl4Hrbl9dmFO1HCR1C86xTDyMmaran50',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
